import React from "react";
import styled from "styled-components";
import CopyInputToClipboard from "components/CopyInputToClipboard";
import ExternalLink from "components/ExternalLink";

export const NumberedStepHeading = styled.div`
  font-size: 15px;
  line-height: ${p => p.theme.OnboardingModal.StepNumber.diameter};
  margin-bottom: ${p => p.theme.margin};
  min-height: ${p => p.theme.OnboardingModal.StepNumber.diameter};
  padding-left: ${p => p.theme.OnboardingModal.NumberedStepContent.marginLeft};
  position: relative;
`;

export const StepNumber = styled.span`
  background-color: ${p => p.theme.OnboardingModal.StepNumber.backgroundColor};
  color: ${p => p.theme.OnboardingModal.StepNumber.color};
  display: inline-block;
  font-size: ${p => p.theme.OnboardingModal.StepNumber.fontSize};
  font-weight: ${p => p.theme.OnboardingModal.StepNumber.fontWeight};
  left: 0;
  margin-right: ${p => p.theme.OnboardingModal.StepNumber.marginRight};
  position: absolute;
  text-align: center;
  vertical-align: top;
  ${p =>
    ["border-radius", "height", "width"].map(
      prop => `
    ${prop}: ${p.theme.OnboardingModal.StepNumber.diameter};`
    )};
`;

export const NumberedStepContent = styled.div`
  margin-left: ${p => p.theme.OnboardingModal.NumberedStepContent.marginLeft};

  p {
    line-height: ${p => p.theme.lineHeight};
    margin-bottom: 1em;
    margin-top: 1em;
  }
`;

const PrecedingContent = styled.div`
  margin-bottom: ${p => p.theme.padding};
`;

export const NumberedStep = ({
  step,
  title,
  content,
  precedingContent,
  CustomStepWrapper,
}) => {
  const DefaultStepWrapper = props => <div {...props} />;
  const StepWrapper = CustomStepWrapper || DefaultStepWrapper;
  return (
    <StepWrapper>
      {precedingContent && (
        <PrecedingContent>{precedingContent}</PrecedingContent>
      )}
      <NumberedStepHeading>
        <StepNumber>{step}</StepNumber>
        {title}
      </NumberedStepHeading>
      {content && <NumberedStepContent>{content}</NumberedStepContent>}
    </StepWrapper>
  );
};

export const CodeBlockWrapper = styled.div`
  background-color: ${p => p.theme.content.backgroundColor};
  border: ${p => p.theme.border};
  margin: ${p => p.theme.padding} 0;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  padding: 15px;
  code {
    font-family: ${p => p.theme.fontFamilyMono};
    white-space: ${p => (p.single ? "nowrap" : "pre")};

    ${p => p.shell && '&:before { content: "$ "; }'};

    ${ExternalLink} {
      text-decoration: none;
    }
  }
`;

export const CodeBlock = ({ children, language, ...props }) => (
  <CodeBlockWrapper {...props}>
    <code data-language={language || "shell"}>{children}</code>
  </CodeBlockWrapper>
);

export const ShellCommand = styled.span`
  display: block;

  &:before {
    content: "$ ";
  }
`;

export const CopyableCodeLine = props => (
  <CopyInputToClipboard tooltipPosition="bottom right" withPrimaryButton>
    {CodeBlock(props)}
  </CopyInputToClipboard>
);

export const InlineCode = styled.span`
  font-family: ${p => p.theme.fontFamilyMono};
`;
